/**
 * @auth 赖传峰
 * @date 2022/9/28
 */
import $track from '~/track/webOfficialWebsite'
import { RoutePath, RoutePathOfDrive } from '~/types/enum'

type TopBarPath = RoutePath | RoutePathOfDrive | string

export default (path?: TopBarPath) => {
  if (!path || !Object.values<TopBarPath>(RoutePath).concat([RoutePathOfDrive.ALL]).includes(path)) return
  $track.web_official_topbar_click({
    button:
      path === RoutePath.HOME
        ? 'introduction'
        : path === RoutePathOfDrive.ALL
          ? 'drive'
          : (path.slice(1) as Parameters<typeof $track.web_official_topbar_click>[0]['button']),
  })
}
